import {IStation, IStationGeoIp, IStationStatsV1, IStationStatsV1V2} from "./stations-interface";
import {
    ICatalogItemCategories,
    ICatalogItemInfos,
    ICatalogItemResources,
    ICatalogItems,
    ICategoryValues,
    Id,
    IEventParam,
    IEventBlock,
    IMusicChannel,
    IMusicChannelSong,
    IPaintSource,
    IResource,
    IPlayerProps,
    ISceneTreeSliceResults,
    ITransitionPool,
    ITransitionPoolItem,
    IGlobalSettings,
    IPreferencesBusiness,
} from "./scenes-interfaces";
import {
    AccountType,
    EnumLoginStatus,
    EnumLoginViewMode,
    EnumStudioType,
    ICart,
    ICartProduct, IPreloadResellerInfo,
    IDynawebsServerReply,
    ILockedRecord,
    IOrderDetails,
    IOrderForm,
    ISceneTemplateImport,
    ISchedule,
    IScheduleEvent, EnumPricingMethod, AccountVersion
} from "./general-interfaces";
import {IEnterpriseReseller, IGroupsPrivileges, IStudio, IWhiteLabelSingle} from "./enterprise-interface";
import {IAccountDetails} from "./enterprise-account-interface";
import {IEnterpriseBusinesses} from "./enterprise-businesses-interface";
import {IEnterpriseBusinessUsers} from "./enterprise-business-users-interface";
import {AdnetPaymentModel} from "../containers/adnet/models/AdnetPaymentModel";
import {AdnetCustomerModel} from "../containers/adnet/models/AdnetCustomerModel";
import {AdnetRateModel} from "../containers/adnet/models/AdnetRateModel";
import {AdnetPairModel} from "../containers/adnet/models/AdnetPairModel";
import {AdnetTransferModel} from "../containers/adnet/models/AdnetTransferModel";
import {AdnetPackageModel} from "../containers/adnet/models/AdnetPackageModel";
import {AdnetTargetModel} from "../containers/adnet/models/AdnetTargetModel";
import {UndoRedoState} from "ngrx-wieder";
import {List} from "immutable";

type exampleReadOnlyLiteral = Readonly<{ firstName: string; lastName: string; }>;
export type BusinessId = string;
export type IAppSettingsWrap = [IUser, IAppStatic];
export type ICRUDCommand =
    'add'
    | 'update'
    | 'delete'
    | 'upload'
    | 'edit'
    | 'reply'
    | 'progress'
    | 'reorder'
    | 'rebuild'
    | 'play'
    | 'stop';

export enum UploadStatus {
    READY,
    INPROGRESS,
    SUCCESS,
    FAILED,
    UPDATING
}

export interface IAccountData {
    status?: boolean;
    changelistId?: number;
    scenes?: Array<IPlayerProps>;
    msg?: string;
    stations?: Array<IStation>;
    branchStations?: Array<IStation>;
    liveStations?: Array<IStation>;
    resources?: Array<IResource>;
    catalogItems?: Array<ICatalogItems>;
    catalogItemInfos?: Array<ICatalogItemInfos>;
    catalogItemResources?: Array<ICatalogItemResources>;
    catalogItemCategories?: Array<ICatalogItemCategories>;
    categoryValues?: Array<ICategoryValues>;
    schedules?: Array<ISchedule>;
    scheduleEvents?: Array<IScheduleEvent>;
    eventParams?: Array<IEventParam>;
    eventsStrings?: Array<string>;
    eventBlocks?: Array<IEventBlock>;
    transitionPools?: Array<ITransitionPool>;
    transitionPoolItems?: Array<ITransitionPoolItem>;
    musicChannels?: Array<IMusicChannel>;
    musicChannelSongs?: Array<IMusicChannelSong>;
    painters?: Array<IPaintSource>;
    globalSettings?: Array<IGlobalSettings>;
    preferences?: IPreferencesBusiness;
}

export interface ISceneItemNewValues {
    key: string;
    value: string | {};
    storePath: string;
    preProcessFunction?: (sceneItemNewValues: ISceneItemNewValues, draft: IUserState, action: ISceneItemsUpdate, sceneTreeSlice: ISceneTreeSliceResults) => void;
    cloneValue?: boolean;
    addIndex?: number;
}

export interface ISceneItemsUpdate {
    sceneId: Id;
    sceneItemId: Id;
    values: Array<ISceneItemNewValues>;
    updatedItemIds?: Array<Id>;
    disableCRUD?: boolean;
}

export interface ISceneItemsSwap {
    sceneId: Id;
    sceneItemId1: Id;
    sceneItemId2: Id;
}

export interface IAdnetURLs {
    request: string;
    search: string;
    save: string;
    report: string;
    billing: string;
}

export interface ICRUDRecordOptions {
    noStringify?: boolean;
    reportProgress?: boolean;
}

export interface ICRUDRecordReply {
    id: Id;
    status: boolean;
    changelist_id?: number;
    resource_bytes_total?: number;
}

export interface ICRUDRecordReadReply {
    player_data_value?: string;
    resource_name?: string;
    resource_type?: string;
    resource_bytes_total?: string;
}

export interface ICRUDRecord {
    studioId: string;
    command: ICRUDCommand;
    body: any;
    table?: string;
    primary?: string;
    name?: string;
    user_id?: string; // global settings
    preference_key?: string; // global settings
    preference_value?: string; // global settings
    preference_id?: any; // global settings
    ext?: string;
    id?: Id | Array<Id>;
    options?: ICRUDRecordOptions;
    serverReply?: ICRUDRecordReply;
    overrideCredentials?: ICRUDOverrides;
}

export interface ICRUDRecordRead {
    businessId: string;
    table: string;
    id: string;
    changelist: string;
    reqFor: string;
}

export interface ICRUDOverrides {
    user: string;
    password: string;
    webApiBaseUrl: string;
    businessId: Id;
}


export interface IUser {
    loginStatus: EnumLoginStatus;
    businessId: string;
    ip: string;
    businessName: string;
    accountStatus: number;
    accountStatusReseller: number;
    pricingMethod: EnumPricingMethod;
    payerId: number;
    accountVersion: AccountVersion;
    customStudio: IWhiteLabelSingle;
    webApiBaseUrl?: string;
    webApiResellerBaseUrl?: string;
    adnetUrls?: IAdnetURLs;
    username: string;
    avatar: string;
    avatarURL: string;
    email: string;
    status: number;
    description: string;
    statusLabel: string;
    isEnabled: boolean;
    createdAt: any;
    updatedAt: any;
    passwordNew: string;
    rememberMe: boolean;
    accessToken: string;
    name: string;
    cardNumber: string;
    cardType: string;
    businessDomain: string;
    resellerId: string;
    mediaCloud: 'CLOUD' | 'PRIVATE' | 'HYBRID';
    studioType: EnumStudioType;    // 0 = Legacy / 1 = Lite / 2 = SignStudio
    enterprise: boolean;           // User is under a reseller
    dashboard: boolean;            // Reseller Dashboard including Adnet, Users, Privileges etc
    plus: boolean;
    applicationId: string;
    webToken: string;
    localStoreConfigVersion: string;
    privilegeId: string;
    accessMask: string;
    archiveState: number;
    sourceId: number;
    fromTemplateId: number;
    maxMonitors: number;
    maxDataStorage: number;
    allowSharing: boolean;
    groupsPrivileges: IGroupsPrivileges;
    billingToken?: string; // when logged in as PLUS user we use billing token which holds reseller payerId to save / load account billing and shipping of reseller and not of plus sub-user
}

export interface ISharedResourceLibrary {
    version: string;
    library: Array<IResourceSharedItem>;
}

export interface IResourceSharedItem {
    $: {
        businessId: string;
        resourceId: string;
        resourceType: string;
        defaultPlayer: string;
        resourceName: string;
        treePath: string;
    };
    url: string;
}

export interface ILog {
    severity: number;
    message: string;
    date?: string;
}

export interface IAppStatic {
    loginState: EnumLoginViewMode;
    appName: string;
    workOffline: boolean;
    isFullFeatures: boolean; // signstudio (release) or pokes (progress)
    localhost: string;
    globalService: string;
    chatService: string;
    konenootService: string;
    masterServer: string;
    privateServer: boolean;
    apiOfflineUrl: string;
    appBaseUrlsAdnet: string;
    studioLiteLegacy: string;
    homePage: string;
    studio_web: string;
    studio_exe: string;
    studio_dmg: string;
    studio_air: string;
    mediadroid: string;
    air_link: string;
    google_play: string;
    player_exe: string;
    player_sign_chrome: string;
    player_sign_chrome_page: string;
    player_apk: string;
    player_legacy_apk: string;
    player_android_sign_watchdog_2024: string;
    player_android_sign_watchdog: string;
    player_android_sign_devices: string;
    player_windows_sign_watchdog_2024: string;
    player_windows_sign_watchdog: string;
    player_linux_sign_watchdog: string;
    player_linux_sign_watchdog_2025: string;
    player_android_watchdog_v1: string;
    player_android_watchdog_v2: string;
    player_air: string;
    player_air_exe: string;
    player_air_dmg: string;
    player_ipa: string;
    player_linux: string;
    productImages: string;
    sampleEventFile: string;
    liveChatUrl: string;
    liveChatUrlV2: string;
    cloudSnapshots: string;
    cloudResourcesS3: string;
    cloudResourcesGPU: string;
    protocol: 'http://' | 'https://';
    googleMapUrl?: string;
    googleMapId?: string;
    amazonOffer?: string;
}

export interface ILoginForm {
    username: string;
    password: string;
}


export interface IDynaWebs {
    order: IOrderForm;
    cart: ICart;
    products: Array<ICartProduct>;
    dynawebsServer: IDynawebsServerReply;
}

export interface IUserState extends UndoRedoState {
    createCredentials: ILoginForm;
    userDetails: IAccountDetails;
    selectedUser: IUser;
    changelistId: number;
    lastGetTime: number;
    scenes: Array<IPlayerProps>;
    dynawebs: IDynaWebs;
    cart: ICart;
    globalSettings: Array<IGlobalSettings>;
    preferences: IPreferencesBusiness;
    twoFactorState: boolean; // null = not used | false = used but did not authenticated | true = used and authenticated
    orders: Array<IOrderForm>;
    order: IOrderDetails;
    painters: Array<IPaintSource>;
    resources: Array<IResource>;
    resourceSharedLibrary: ISharedResourceLibrary;
    catalogItems: Array<ICatalogItems>;
    catalogItemInfos: Array<ICatalogItemInfos>;
    catalogItemResources: Array<ICatalogItemResources>;
    catalogItemCategories: Array<ICatalogItemCategories>;
    categoryValues: Array<ICategoryValues>;
    schedules: Array<ISchedule>;
    scheduleEvents: Array<IScheduleEvent>;
    transitionPools: Array<ITransitionPool>;
    transitionPoolItems: Array<ITransitionPoolItem>;
    musicChannels: Array<IMusicChannel>;
    musicChannelSongs: Array<IMusicChannelSong>;
    eventParams: Array<IEventParam>;
    eventsStrings: Array<string>;
    eventBlocks: Array<IEventBlock>;
    stations: Array<IStation>;
    liveStations: Array<IStation>;
    stationStats: Array<IStationStatsV1>;
    userStationGeoIPs: Array<IStationGeoIp>;
    // userStationTrack: Array<IStationTrackReply>;
    // userStationTrackStats: Array<IStationTrackReply>;
    sceneTemplateImports: Array<ISceneTemplateImport>;
    lockedRecord: ILockedRecord;
    previousLinkedSceneId: Id;
    previousSlidesSceneId: Id;
    crudScene: ICRUDScene;
    preLoginResellerInfo: IPreloadResellerInfo;
    knownUsers?: any;
}

export interface IAdnetState {
    customers: List<AdnetCustomerModel>;
    rates: List<AdnetRateModel>;
    pairs: List<AdnetPairModel>;
    packages: List<AdnetPackageModel>;
    targets: List<AdnetTargetModel>;
    targets_search: List<AdnetTargetModel>;
    reports: List<any>;
    payments: List<AdnetPaymentModel>;
    transfers: List<AdnetTransferModel>;
}

export interface IEnterpriseState {
    enterpriseAccount: IAccountDetails;
    enterpriseReseller: IEnterpriseReseller;
    enterpriseBusiness: IEnterpriseBusinesses;
    enterpriseStations: Array<IStationStatsV1V2>;
    enterpriseStationGeoIPs: Array<IStationGeoIp>;
    // enterpriseStationTrack: Array<IStationTrackReply>;
    // enterpriseStationTrackStats: Array<IStationTrackReply>;
    enterpriseBusinessUsers: IEnterpriseBusinessUsers;
}

export interface ITransitionItemUpdate {
    transition_pool_id: string;
    transition_pool_item_id?: string;
    store_path?: string;
    key?: string;
    value: any;
}

export interface FileObj {
    fileName: string;
    file?: File;
    fileType: string;
    fileId?: string;
    uploadStatus?: number;
    progress?: number;
    formattedSize?: string;
    fileSize?: number;
    width?: number;
    height?: number;
    googleDriveLink?: string;
    skipAutoBackground?: boolean; // Flag to prevent auto-setting as background (for AI "add as resource")
}

export interface ICRUDScene {
    command: ICRUDCommand;
    sceneId?: string;
    itemIds?: Array<string>;
    disableSync?: boolean;
}

export interface IJumpLink {
    previousLinkedSceneId?: Id;
    previousSlidesSceneId?: Id;
}


// export interface IUndoRedo {
//     canUndo: boolean,
//     canRedo: boolean
// }

// export interface IUserHttp {
//   users: IUser[];
// }
//
// export interface IUserAccountDataHttp {
//   data: any;
// }


